import { ReleasesApi } from '@/state/api';
import { permissionsKeys } from '@/types/permissionsType';
import { AllowedTab, getAllowedTabs } from '@/utils/permissionUtils';
import { HStack, Stack } from '@chakra-ui/react';
import { useAppSelector } from '@state';
import { Accordion, AccordionContent, SelectLabels } from '@ui';
import React from 'react';
import { FaEdit } from 'react-icons/fa';
import BomImports from '../BomImports';
import ManageCard from '../ManageCard';

const Manage: React.FC = () => {
  const selectedRelease = useAppSelector(
    (state) => state.release.selectedRelease,
  );

  const { data: releaseById } = ReleasesApi.Api.useGetReleaseByIdQuery(
    {
      releaseId: selectedRelease.id!,
    },
    {
      skip: !selectedRelease?.id,
    },
  );

  const allowedAccordion = getAllowedTabs(accordionsList);

  return (
    <Stack gap={5}>
      <SelectLabels
        items={[
          {
            label: 'Release',
            value: selectedRelease.item?.number,
          },
        ]}
      />
      <BomImports />

      {allowedAccordion?.map((accordion) => (
        <Accordion
          key={accordion.value}
          items={[accordion]}
          defaultValue={[
            accordion.value === allowedAccordion[0].value
              ? accordion.value
              : '',
          ]}
        >
          <AccordionContent value={accordion.value}>
            {accordion.value === accordionsList[0].value && (
              <ManageCard
                isNew={true}
                defaultRelease={releaseById ?? undefined}
              />
            )}
            {accordion.value === accordionsList[1].value && (
              <ManageCard
                isNew={false}
                defaultRelease={releaseById ?? undefined}
                key={`release-update-${releaseById?.id}`}
              />
            )}
          </AccordionContent>
        </Accordion>
      ))}
    </Stack>
  );
};

export default Manage;

const accordionsList = [
  {
    label: (
      <HStack textStyle="heading.sub" color="secondary.fg" gap={2}>
        <FaEdit />
        Create Release
      </HStack>
    ),
    value: 'createRelease',
    permissions: [permissionsKeys.add_release],
  },
  {
    label: (
      <HStack textStyle="heading.sub" color="secondary.fg" gap={2}>
        <FaEdit />
        Edit Release Details
      </HStack>
    ),
    value: 'editReleaseDetails',
    permissions: [permissionsKeys.change_release],
  },
] satisfies AllowedTab[];
